import React from "react";
import styles from "./styles.module.scss";
import { AwaitingInstallIcon } from "../../Styles/Icons/DesignSystem/AwaitingInstallIcon";

interface StatusButtonProps {
  text: string;
  onTrack: (event: string, properties: Record<string, any>) => void;
  onClick: () => void;
}
const StatusButton = ({ text, onClick }: StatusButtonProps) => {
  return (
    <div className={styles.awaiting_install_button_container} onClick={onClick}>
      <div className={styles.awaiting_install_icon_container}>
        <AwaitingInstallIcon />
      </div>
      <div className={styles.awaiting_install_text_content_container}>
        <div className={styles.awaiting_install_text}>{text}</div>
        <div className={styles.click_to_view_text}>Click to view</div>
      </div>
    </div>
  );
};

export default StatusButton;
